/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-shadow */
export enum LetterLanguage {
  English = 'English',
  Spanish = 'Spanish',
}
